import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight, Wallet } from "lucide-react";
import { useCheckInSend } from "../context";
import { useAudio } from "../../../../../lib/use-audio";
import { KioskStep } from "../../../../../components/kiosk-step";
import { KioskStatePanel } from "../../../../../components/kiosk-state-panel";

/**
 * Self-pay step: the patient acknowledges paying the treatment themselves, or
 * goes back to the insurance choice (KC-28).
 *
 * @since 1.0.0
 * @example
 * ```tsx
 * <SelfPayStep />
 * ```
 */
export function SelfPayStep() {
  const { t } = useTranslation();
  const send = useCheckInSend();

  // Play audio on mount
  useAudio("checkIn-selfPay");

  return (
    <KioskStep
      width="narrow"
      title={t("self-service.check-in.self-pay.title-v2")}
      primaryAction={{
        label: t("common.next"),
        icon: ArrowRight,
        onClick: () => send({ type: "SUBMIT_SELF_PAY" }),
        testId: "self-pay-confirm",
      }}
      secondaryAction={{
        label: t("self-service.check-in.self-pay.insured-after-all"),
        icon: ArrowLeft,
        onClick: () => send({ type: "BACK" }),
        testId: "self-pay-insured-after-all",
      }}
    >
      <KioskStatePanel
        tone="info"
        icon={<Wallet />}
        title={t("self-service.check-in.self-pay.subtitle-v2")}
        body={t("self-service.check-in.self-pay.info")}
      />
    </KioskStep>
  );
}
